import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures, eUserRole, eViewMode } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { VoiceTree, VoiceTreeOption } from '../../../models/voiceTreeList';
import { GlobalService } from '../../../services/global.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { VoiceCallService } from '../../../services/voice-call.service';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { NotificationService } from '../../../services/notification.service';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';

@Component({
    selector: 'app-voice-tree-option',
    templateUrl: './voice-tree-option.component.html',
    styleUrl: './voice-tree-option.component.css',
    providers: [GridConfigurationService]
})
export class VoiceTreeOptionComponent {
    private encryptedUser: string = '';
    showSpinner: boolean = false;
    user: CLPUser;
    userResponse: UserResponse;
    messageType: string = "";
    @Input() voiceTreeId: number = 0;
    @Input() voiceTreeOptionId: number = 0;
    @Input() selectedOption: VoiceTreeOption | null = null;
    vtOptionForm: FormGroup;
    @Input() isAddMode: boolean = false;
    @Input() isEditMode: boolean = false;
    @Input() isViewMode: boolean = true;
    roleFeaturePermissions: RoleFeaturePermissions;
    voiceTree: VoiceTree;
    @Output() closeVoiceOption = new EventEmitter<boolean>();
    @Output() optionSaved = new EventEmitter<void>();
    @Output() optionDeleted = new EventEmitter<void>();
    message: string = "";
    isConfirmed: boolean = false;
    constructor(private fb: FormBuilder,
        private _globalService: GlobalService,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private route: ActivatedRoute,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,
        private _voiceCallService: VoiceCallService,
        private _accountSetupService: AccountSetupService,
        private _notifyService: NotificationService,
    ) {

    }

    ngOnInit(): void {
        this.vtOptionForm = this.prepareVTOptionForm();
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.setup();
                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        })
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    const response = UtilityService.clone(result);
                    if (!isNullOrUndefined(response)) {
                        if (!isNullOrUndefined(response?.user)) {
                            this.user = response.user;
                            this.roleFeaturePermissions = response.roleFeaturePermissions;
                            this._gridCnfgService.user = this.user;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("voice-tree.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    //prepareVTOptionForm() {
    //    return this.fb.group({
    //        voiceTreeOptionID: new FormControl(0),
    //        voiceTreeID: this.voiceTreeId,
    //        digit: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
    //        name: ['', [Validators.required]],
    //        optionType: new FormControl(0),
    //        optionValue: ['', [Validators.required], Validators.pattern('^[0-9]+$') ],
    //        announceScript: new FormControl(""),
    //        sOrder: new FormControl(0)
    //    });
    //}

    prepareVTOptionForm() {
        return this.fb.group({
            voiceTreeOptionID: new FormControl(0),
            voiceTreeID: this.voiceTreeId,
            digit: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            name: ['', [Validators.required]],
            optionType: new FormControl(0),
            optionValue: [
                '',
                [
                    Validators.required,
                    Validators.pattern(/^[0-9]+$/)
                ]
            ],
            announceScript: new FormControl(""),
            sOrder: new FormControl(0)
        });
    }

    patchVTOptionForm(vtOption: VoiceTreeOption): void {
        this.vtOptionForm.patchValue({
            voiceTreeOptionID: vtOption.voiceTreeOptionID,
            voiceTreeID: this.voiceTreeId,
            digit: vtOption.digit,
            name: vtOption.name,
            optionType: Number(vtOption.optionType),
            optionValue: vtOption.optionValue,
            announceScript: vtOption.announceScript,
            sOrder: vtOption.sOrder
        });
    }

    async setup() {
        if (this.voiceTreeId > 0) {
            if (this.voiceTreeOptionId > 0) {
                await this.voiceTreeOptionLoad(this.voiceTreeOptionId);
            } else {
                await this.VoiceTreeGetNextDigit(this.voiceTreeId);
            }
        }
    }

    async onSaveOption() {
        this.vtOptionForm.markAllAsTouched();
        this.vtOptionForm.updateValueAndValidity();
        if (this.vtOptionForm.valid) {
            const formValue = this.vtOptionForm.value;
            console.log(formValue, "changes made");
            await this._voiceCallService.VoiceTreeOptionUpdate(this.encryptedUser, formValue)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            await this.voiceTreeOptionLoad(response.messageInt);
                            this._notifyService.showSuccess('Option Updated successfully.', "", 3000);
                            this.optionSaved.emit();
                            this.isViewMode = true;
                            this.message = "Option saved.";

                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async voiceTreeGet(voiceTreeID: number) {
        await this._voiceCallService.voiceTreeGet(this.encryptedUser, voiceTreeID)
            .then(async (result: VoiceTree) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (response.voiceTreeID > 0) {
                        this.voiceTree = response;

                    }

                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async voiceTreeOptionLoad(voiceTreeOptionID: number) {
        await this._voiceCallService.voiceTreeOptionLoad(this.encryptedUser, voiceTreeOptionID)
            .then(async (result: VoiceTreeOption) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (response.voiceTreeID > 0) {
                        this.selectedOption = response;
                        this.patchVTOptionForm(this.selectedOption);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async VoiceTreeGetNextDigit(voiceTreeID: number) {
        if (voiceTreeID > 0) {
            await this._voiceCallService.VoiceTreeGetNextDigit(this.encryptedUser, voiceTreeID)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.vtOptionForm.patchValue({
                                name: '',
                                digit: response.messageInt,
                                voiceTreeID: this.voiceTreeId,
                                optionType: 0,
                                optionValue: '',
                                announceScript: '',
                                sOrder: 0,
                                voiceTreeOptionID: 0
                            });
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    getOptionTypeName(vrId: number) {
        //if (vrId && vrId > 0 && this.vrDDList && this.vrDDList.length > 0)
        //    return this.vrDDList?.find(x => x.id == vrId).text;
        //else return '-Not Selected-';
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log(changes, "changes");
        if (!this.vtOptionForm) return;
        const option = changes['selectedOption']?.currentValue;
        if (!option) return;
        if (option.voiceTreeOptionID === 0) {
            this.voiceTreeOptionId = option.voiceTreeOptionID;
            if (this.isEditMode) {
                this.isViewMode = false;
            }
            this.VoiceTreeGetNextDigit(this.voiceTreeId);
        }
        else {
            if (this.isEditMode) {
                this.isViewMode = false;
            }
            this.voiceTreeOptionId = option.voiceTreeOptionID;
            this.patchVTOptionForm(option);
        }
    }
    async vtOptionDelete() {
        if (this.selectedOption?.voiceTreeOptionID) {
            await this._voiceCallService.VoiceTreeOptionDelete(this.encryptedUser, this.selectedOption?.voiceTreeOptionID)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this._notifyService.showSuccess('Option has been deleted.', "", 3000);
                            this.optionSaved.emit();
                            this.optionDeleted.emit();
                            this.vtOptionForm.reset();
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    cancel() {
        if (this.voiceTreeOptionId == 0) {
            this.closeVoiceOption.emit(true);
        }
        this.vtOptionForm.reset();
        this.patchVTOptionForm(this.selectedOption);
        this.message = "No changes have been made.";
        this.isConfirmed = false;
    }

    deleteConfirm() {
        this.message = "Please confirm this action.";
    }

    numbersOnly(event: KeyboardEvent) {
        const charCode = event.which ? event.which : event.keyCode;

        if (charCode === 8) return; // allow backspace

        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    }

}
